import React, { useState } from "react";
import { toast } from "sonner";
import { http } from "@/lib/api";
import { PageHeader, Section, Reveal } from "@/components/Section";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TID } from "@/constants/testIds";

const baseInput =
  "w-full bg-black/60 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-white/30 focus:outline-none focus:border-[#FF9933] focus:ring-1 focus:ring-[#FF9933]/60 transition-all";

const Field = ({ label, children }) => (
  <label className="block">
    <span className="text-[10px] uppercase tracking-[0.35em] text-white/50">{label}</span>
    <div className="mt-2">{children}</div>
  </label>
);

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "", kind: "general" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await http.post("/contact", form);
      toast.success("Received. We'll reply within 48 hours.");
      setForm({ name: "", email: "", subject: "", message: "", kind: "general" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <PageHeader
        eyebrow="Contact"
        hindi="संपर्क"
        title="Business, Press &amp; Collaborations"
        subtitle="For general enquiries, press, business partnerships and collaboration requests."
      />
      <Section className="!py-16">
        <Reveal>
          <form onSubmit={submit} className="max-w-3xl glass rounded-2xl p-8 space-y-5">
            <Field label="Enquiry Type">
              <Select value={form.kind} onValueChange={(v) => setForm({ ...form, kind: v })}>
                <SelectTrigger data-testid={TID.contactKind} className={baseInput}>
                  <SelectValue placeholder="Select..." />
                </SelectTrigger>
                <SelectContent className="bg-[#0f0f0f] border border-white/10 text-white">
                  <SelectItem value="general">General</SelectItem>
                  <SelectItem value="business">Business Partnership</SelectItem>
                  <SelectItem value="press">Press / Media</SelectItem>
                  <SelectItem value="licensing">Music Licensing</SelectItem>
                </SelectContent>
              </Select>
            </Field>
            <div className="grid md:grid-cols-2 gap-5">
              <Field label="Your Name">
                <input data-testid={TID.contactName} required className={baseInput} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Full name" />
              </Field>
              <Field label="Email">
                <input data-testid={TID.contactEmail} required type="email" className={baseInput} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="you@example.com" />
              </Field>
            </div>
            <Field label="Subject">
              <input data-testid={TID.contactSubject} required className={baseInput} value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} placeholder="What is this about?" />
            </Field>
            <Field label="Message">
              <textarea data-testid={TID.contactMessage} required rows={6} className={`${baseInput} resize-none`} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Tell us everything..." />
            </Field>
            <button
              data-testid={TID.contactSubmit}
              disabled={busy}
              className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#FF9933] text-black px-6 py-3 text-xs uppercase tracking-[0.3em] font-semibold hover:bg-[#FFD700] hover:shadow-[0_0_30px_rgba(255,153,51,0.55)] transition-all disabled:opacity-60"
            >
              {busy ? "Sending..." : "Send Message"}
            </button>
          </form>
        </Reveal>
      </Section>
    </>
  );
};

export default Contact;
